import React, { FC } from 'react';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import ImageHandlingPopup, { ImageHandlingPopupItem } from '@v2/components/imageHandling/components/Header/components/ImageHandlingPopup';
import { ImageHandlingHeaderProps } from '@v2/components/imageHandling/components/Header/Header';
import { useManageInfoPopupWeb } from './hooks/useManageInfoPopupWeb';

export interface InfoPopupWebProps
  extends Pick<ImageHandlingHeaderProps, 'images' | 'selectedIndex' | 'setSelectedIndex' | 'deleteImage' | 'C' | 'scale' | 'font'> {
  visible: boolean;
  onClose: () => void;
  list?: ImageHandlingPopupItem[] | null;
  iconPosition?: { x: number; y: number };
}

const InfoPopup: FC<InfoPopupWebProps> = ({
  images,
  selectedIndex,
  deleteImage,
  C,
  setSelectedIndex,
  visible,
  onClose,
  list: listFromProps,
  scale = initialScale,
  font = initialFont,
  iconPosition,
}) => {
  const { list } = useManageInfoPopupWeb({ deleteImage, images, selectedIndex, setSelectedIndex, font, list: listFromProps, C });

  if (!visible) return null;

  return <ImageHandlingPopup {...{ C, list, loading: false, onClose, scale, font, iconPosition }} />;
};

export default InfoPopup;
